export default "__VITE_ASSET__603a74d1__"